import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, setVariableMapping } from 'store/data/variablesMapping';

type HandlerInput = Parameters<typeof setVariableMapping>;

export function useSetVariableMapping(activityPayload: {
	variableName: string;
}): Operation<(...input: HandlerInput) => Promise<void>> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(
		ActionTypes.SET_VARIABLE_MAPPING,
		activityPayload
	);

	async function handler(...input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		await dispatch(setVariableMapping(...input));
	}

	return [{ loading, error }, handler];
}
